"use strict";
var newCtrl = require('import/controllers/newCtrl');
var navCtrl = require('common/controllers/navCtrl');
var app = angular.module('import', ['templates', 'lr.upload', 'ngFlash']);
app.controller('newCtrl', ['$scope', '$rootScope', '$http', 'upload', 'Flash', newCtrl]);
app.controller('navCtrl', ['$scope', navCtrl]);
module.exports = app;
